export { default as mapCompositeRenderPollResponse } from './mapCompositeRenderPollResponse';
